// AUTO-GENERATED — do not edit.
export const APP_VERSION: string = '0.26.0'
